module.exports = __webpack_public_path__ + "static/media/canvaskit.wasm.b0bd1688.asset";